export function MyFooter (){
    return (
        <footer>
            <a href={document.URL}>
                View Online
            </a>
        </footer>
    )
}